import { render, staticRenderFns } from "./Wp_limit_commission_share_model.vue?vue&type=template&id=7be1daba&scoped=true&"
import script from "./Wp_limit_commission_share_model.vue?vue&type=script&lang=js&"
export * from "./Wp_limit_commission_share_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be1daba",
  null
  
)

export default component.exports